
// BEWARE! This is relative to the UI located at ".../plugin/auth2/"!
// API calls will break if you move UI pages within subdirectories!
// It was made on purpose using relative URLs to be "proxy-friendly"
export const API_URL = '../de.elo.ix.plugin.rest/auth2'

export const buefyConfig = {
    defaultIconPack: 'e-icon', // EAUTH2-33
}

export function isEmpty(obj) :boolean {
    return !obj || Object.keys(obj).length === 0
}

export function isInsideIFrame() :boolean {
    return (window.top !== window.self)
}

export async function fetchJson(url :string) :Promise<any> {
    try {
        const req = await fetch(url)
        if (!req.ok)
            throw `Unexpected response status: ${req.status}`

        const json = await req.json()
        console.debug(json)

        return json
    }
    catch(e) {
        console.error(e)
        alert(`Failed to fetch ${url}`)
        throw e
    }
}


const DEFAULT_ELO_LOCALES = [
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "es-419",
    "fi",
    "fr",
    "hu",
    "id",
    "it",
    "nl",
    "pl",
    "pt",
    "pt-BR",
    "ro",
    "sk",
    "sr",
    "sr-Cyrl",
    "tr"
]


export async function fetchMessages() :Promise<Record<string, string>> {
    const locale = pickLocaleFrom(DEFAULT_ELO_LOCALES)
    const messages = await fetchJson(`./locales/sign-in-${locale}.json`)
    messages['LOCALE'] = locale
    document.documentElement.lang = locale;
    return messages
}

export function  getDefaultLocale() {
    return pickLocaleFrom(DEFAULT_ELO_LOCALES);
}


export function pickLocaleFrom(locales :string[]) {
    // contains the browser locales/languages by order of preference
    let langs = navigator.languages
    if(!langs)
        langs = [navigator.language]

    for(const lang of langs) {
        if (locales.includes(lang))
            return lang
        // Fallback to the more generic language (example "pt-BR" -> "pt")
        const shortCode = lang.split("-")[0]
        if (locales.includes(shortCode))
            return shortCode
    }

    return locales[0];
}


export function getTimezone() :string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}
